/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Typography,
  Spin,
  Input,
  Modal,
  message,
  Tabs,
  Card,
  notification,
  DatePicker,
  Alert,
  Menu,
  Tag,
} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import descargarPDFGeneral from 'components/PDF/descargarPDFGeneral';
import { formatReceived } from 'utils/formatValues';
import Uploader from 'components/Uploader';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales, getPeriodicidadesDePagos, getTiposDeNomina } from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import { readPersistedTableQuery } from 'utils/tableFiltersStorage';
import { NOMBRES_PATTERN } from 'utils/patterns';
import API from 'utils/api';
// API_HOST y API_SCHEME eliminados: polling usa API directo sin WebSocket
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  NOMINA_ORDINARIA,
  SUBTIPO_NOMINA_EXTEMPORANEO,
  SUBTIPO_NOMINA_NINGUNO,
} from 'utils/constants';
import { getConceptosCargaExterna } from 'api/catalogos/ConceptosCargaExterna';
import { getModelPermission } from 'utils/permission';
import {
  autorizarExternaDescuentoAEmpleados,
  CancelarExternaDescuento,
  deleteExternaDescuento,
  getExternaDescuento,
  getExternaDescuentoErrores,
  getExternaDescuentos,
  getExternaDescuentosTotales,
  patchExternaDescuento,
  postExternaDescuento,
  putExternaDescuento,
  reactivarExternaDescuento,
} from 'api/catalogos/CargaExternaDescuento';
import * as XLSX from 'xlsx';
import { getTodosDescuentos } from 'api/catalogos/TodosDescuentos';
import { getSubtiposNominas } from 'api/nominas/subtiposDeNominas';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getReporteIPEJALPatronalVivienda } from 'api/nominas/reporteIPEJALPatronalVivienda';
import { clasificarGrupoIPEJAL } from 'utils/clasificacionIPEJAL';
import moment from 'moment/moment';
import ExcelJS from 'exceljs';
import { getConfiguracionExternaDescuentos } from 'api/catalogos/ConfiguracionCargaExternaDescuento';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import ModalErroresControls from 'components/ModalErroresControls';
import currencyFormatter from 'utils/currencyFormatter';
import CargaExternaDescuentoDetalle from './CargaExternaDescuentosDetalle';

export const CargaExternaDescuentoPermission = {
  permissionModel: 'descuentocargaexternaarchivo',
  catalogsModels: [],
  tabsModels: [],
};
const { TabPane } = Tabs;
const { Text } = Typography;

// Id fijo de la tabla principal: todos los tabs comparten la misma búsqueda.
const TABLE_STORAGE_ID = 'carga-externa-descuentos';
// Búsqueda capturada en cualquier tab (se incluye al pedir los datos de otro tab o al recargar).
const busquedaGuardada = () => readPersistedTableQuery(window.location.pathname, {
  storageId: TABLE_STORAGE_ID,
});

// `fecha_de_carga` es fecha-hora en UTC y el grid la muestra en hora local: una carga hecha de
// noche aparece en el grid con el día local, pero en UTC ya es el día siguiente. Por eso la
// búsqueda por día (dd/mm/aaaa) se envía como el rango de ese día en la hora local del
// usuario, convertido a UTC (fecha_de_carga_desde / fecha_de_carga_hasta).
// Fechas de los periodos de nómina en dd/mm/aaaa (el API las manda en ISO), como en el resto
// del sistema; el filtro periodos_de_nomina_detalle del backend compara contra este mismo texto.
const fechaDMY = (valor) => (valor ? moment(valor).format('DD/MM/YYYY') : '');

const conRangoFechaDeCarga = (q) => {
  const valor = q?.fecha_de_carga;
  if (typeof valor !== 'string' || !/^\d{2}\/\d{2}\/\d{4}$/.test(valor.trim())) return q;
  const dia = moment(valor.trim(), 'DD/MM/YYYY', true);
  if (!dia.isValid()) return q;
  const { fecha_de_carga: _omitida, ...resto } = q;
  return {
    ...resto,
    fecha_de_carga_desde: dia.clone().startOf('day').toISOString(),
    fecha_de_carga_hasta: dia.clone().endOf('day').toISOString(),
  };
};

const CargaExternaDescuento = ({ permission }) => {
  const entidad = useSelector((state) => state.auth.entidad);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [activetotal, setTotal] = useState('Total');
  const [conceptosCargaExterna, setConceptosCargaExterna] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [descuentos, setDescuentos] = useState([]);
  const [tiposNominas, setTiposNominas] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [periodo, setPeriodo] = useState();
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [periodosFiltered, setPeriodosFiltered] = useState([]);
  const [disableSubtipo, setDisableSubtipo] = useState(true);
  const [subtiposDeNomina, setSubtiposDeNomina] = useState([]);
  const [subtiposFiltered, setSubtiposFiltered] = useState([]);
  const [payloadRegistros, setPayloadRegistros] = useState(null);
  const [ConfiguracionExterna, setConfiguracionExterna] = useState([]);
  const registrosExcelRef = useRef([]);
  const archivoFileRef = useRef(null);
  const isEditing = selectedRowKeys.length > 0;
  const formInstances = [
    form,
  ];
  const [visibleErrores, setVisibleErrores] = useState(false);
  const [errores, setErrores] = useState([]);
  const pollingRef = useRef(null);
  const [idEnProceso, setIdEnProceso] = useState(null);
  const [isPolling, setIsPolling] = useState(false);
  // snapshot: { id, descripcionProceso, onCerrar }
  const [pollingSnapshot, setPollingSnapshot] = useState(null);
  // Contador de progreso leído desde ProcesoEnCursoTerminado
  const [progresoActual, setProgresoActual] = useState({ en_curso: 0, total: 0 });
  const detalleRef = useRef(null);
  const [totales, setTotales] = useState([]);
  const [excelUpdateKey, setExcelUpdateKey] = useState(0);
  const [usarRegistrosLocales, setUsarRegistrosLocales] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [isModalProgresoVisible, setIsModalProgresoVisible] = useState(false);
  const isSpinning = loading;
  // La pantalla abre en "Todos" (primer tab).
  const [tabEstadoActivo, setTabEstadoActivo] = useState('todos');

  const baseURI = '/nominas/descuentos-carga-externa-archivo/';

  // `todos: null` -> no se envía `estados_globales` y el API regresa Activos,
  // Autorizados y Cancelados juntos (el filtro es opcional en su FilterSet).
  const TAB_ESTADOS_CARGA_EXTERNA = {
    todos: null,
    activos: ESTATUS_ACTIVO,
    autorizados: ESTATUS_AUTORIZADO,
    cancelados: ESTATUS_CANCELADO,
  };
  const paramsEstado = (tabKey) => {
    const estado = TAB_ESTADOS_CARGA_EXTERNA[tabKey];
    return estado ? { estados_globales: estado } : {};
  };

  const fetchData = async (page = 1, q = null) => {
    const safePage = Math.max(1, parseInt(page, 10) || 1);
    setLoading(true);
    try {
      const _data = await API.get(baseURI, {
        params: {
          page: safePage,
          ...paramsEstado(tabEstadoActivo),
          ...conRangoFechaDeCarga(q ?? busquedaGuardada()),
        },
      });
      const { results } = _data.data;
      setData({ ..._data.data, results });
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const fetchConceptos = async () => {
    const _ConfiguracionExterna = await getConfiguracionExternaDescuentos();
    setConfiguracionExterna(_ConfiguracionExterna?.results || []);

    const conceptos = await getConceptosCargaExterna();
    setConceptosCargaExterna(conceptos);

    const descuento = await getTodosDescuentos();
    const descuentosFormateados = descuento.map((item) => ({
      ...item,
      descripcion: `${item.clave} - ${item.concepto}`,
    }));
    setDescuentos(descuentosFormateados);

    // Aquí hacemos fetch de estados globales solo después de obtener los conceptos
    const _estados = await getEstadosGlobales();
    setEstados(_estados);
  };

  const fetchPaginated = async (page = 1, q = null) => {
    const cleanPage = Math.max(1, parseInt(page, 10) || 1);
    try {
      setLoading(true);
      const response = await API.get(baseURI, {
        params: {
          page: cleanPage,
          ...paramsEstado(tabEstadoActivo),
          ...conRangoFechaDeCarga(q),
        },
      });
      const { results } = response.data;
      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onChangeTabEstado = async (key) => {
    setTabEstadoActivo(key);
    setSelectedRowKeys([]);
    setSelectedData({});
    setPageActual(1);
    setLoading(true);
    try {
      const response = await API.get(baseURI, {
        params: { page: 1, ...paramsEstado(key), ...conRangoFechaDeCarga(busquedaGuardada()) },
      });
      const { results } = response.data;
      setData({ ...response.data, results });
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllErrores = async (params) => {
    let allResults = [];
    let page = 1;
    let hasNext = true;

    while (hasNext) {
      // eslint-disable-next-line no-await-in-loop
      const response = await getExternaDescuentoErrores({ ...params, page });
      if (response?.results?.length) {
        allResults = allResults.concat(response.results);
      }
      hasNext = !!response?.next;
      page += 1;
    }

    return allResults;
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposNominas,
        _tiposNominasEmpleados,
        _periodicidades,
        _periodosNominasDetalles,
        _periodosFiscales,
        _periodosNominas,
        _subtiposDeNomina,
        _data,
      ] = await Promise.all([
        getTiposDeNomina(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getSubtiposNominas(),
        // Carga inicial del tab "Todos": sin filtro de estatus.
        getExternaDescuentos({}),
      ]);
      const { results } = _data;
      if (mounted) {
        setTiposNominas(_tiposNominas);
        setTiposNominasEmpleados(_tiposNominasEmpleados);
        setPeriodicidades(_periodicidades);
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setPeriodosFiscales(_periodosFiscales);
        setPeriodosNominas(_periodosNominas);
        setSubtiposDeNomina(_subtiposDeNomina);
        setSubtiposFiltered(_subtiposDeNomina);
        setData({ ..._data, results });
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const getFechaServidor = async () => ({ fecha: new Date().toISOString() });

  const obtenerFechaServidorYSetear = async () => {
    try {
      const { fecha } = await getFechaServidor(); // retorna string tipo "2025-06-24T18:15:00Z"
      form.setFieldsValue({
        fecha_de_carga: moment(fecha), //  convertir string ISO a moment
      });
    } catch (err) {
      message.error('No se pudo obtener la fecha del servidor');
    }
  };

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
    setLoading(false);
    setPayloadRegistros(null);
    registrosExcelRef.current = [];
    archivoFileRef.current = null;
    setIdEnProceso(null);
    setIsPolling(false);
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
    fetchData(pageActual); // recarga la tabla
    setUsarRegistrosLocales(false);
  };

  const filterPeriodos = async (_data) => {
    const {
      tipos_de_nomina_empleado,
      periodo_fiscal,
      periodos_de_nomina_detalle,
    } = form.getFieldsValue();

    const _periodo = periodo_fiscal || _data?.periodo_fiscal;
    // eslint-disable-next-line max-len
    const _tipos_nomina = tipos_de_nomina_empleado || _data?.tipos_de_nomina_empleado || [];
    // eslint-disable-next-line max-len
    const _detallesSeleccionados = periodos_de_nomina_detalle || _data?.periodos_de_nomina_detalle || [];

    const _periodosNominas = periodosNominas.filter(
      (e) => _tipos_nomina.includes(e.tipo_de_nomina_empleado)
      && e.periodo_fiscal === _periodo,
    );

    const _periodosDetallesFiltered = periodosNominasDetalles.filter(
      (e) => _periodosNominas.some((x) => x.id === e.periodo_de_nomina),
    );

    //  Agrega explícitamente los periodos seleccionados si no están incluidos
    _detallesSeleccionados.forEach((id) => {
      const detalle = periodosNominasDetalles.find((e) => e.id === id);
      if (detalle && !_periodosDetallesFiltered.some((e) => e.id === detalle.id)) {
        _periodosDetallesFiltered.push(detalle);
      }
    });

    setPeriodosFiltered(_periodosDetallesFiltered);
  };

  const filterSubtipos = (value) => {
    setDisableSubtipo(!value);

    let _filteredSubtipos;
    if (value === NOMINA_ORDINARIA) {
      _filteredSubtipos = subtiposDeNomina.filter(
        (e) => e?.id === SUBTIPO_NOMINA_NINGUNO
        || e?.id === SUBTIPO_NOMINA_EXTEMPORANEO,
      );
    } else {
      _filteredSubtipos = subtiposDeNomina;
    }
    setSubtiposFiltered(_filteredSubtipos);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    try {
      // Solo al abrir desde el boton "Editar" (sin responseData) se fuerza el tab Empleados.
      // Las llamadas internas (refrescar tras Autorizar/Reactivar) pasan responseData y deben
      // respetar el tab que el usuario tenga abierto en ese momento (p.ej. viendo Totales).
      if (!responseData) {
        setCurrentTabKey('general');
      }
      // responseData?.id cubre el caso donde se llama justo después de setSelectedRowKeys()
      // en el mismo tick (ej. al terminar el polling de Autorizar/Carga): selectedRowKeys
      // todavía no se actualiza (los estados de React se aplican en el siguiente render),
      // así que leerlo del cierre aquí devolvería el valor viejo.
      const key = responseData?.id || selectedRowKeys[0];
      const match = await getExternaDescuento(key);

      if (!key) {
        message.warn('No se encontró el registro seleccionado');
        return;
      }
      //  Consultar errores asociados al registro (todas las páginas)
      const erroresAll = await fetchAllErrores({
        descuento_carga_externa_archivo: key,
      });

      if (erroresAll?.length) {
        setErrores(erroresAll); //  Mostrar alerta e historial
      } else {
        setErrores([]); //  Nada que mostrar
        setVisibleErrores(false);
      }
      form.resetFields();
      await fetchConceptos(); // asegúra de tener los catálogos

      // eslint-disable-next-line max-len
      await filterPeriodos(match); //  importante: actualiza periodosFiltered con el registro a editar
      form.setFieldsValue(formatReceived(match));
      // CRÍTICO: mantiene sincronizado el prop CargaExternaDescuento (=selectedData) que
      // recibe el componente hijo de Empleados con el estatus real y recién obtenido del
      // registro. Sin esto, tras Autorizar/Reactivar el formulario muestra el estatus nuevo
      // (viene de form.setFieldsValue) pero selectedData sigue con el valor viejo (ej. Activo),
      // y el hijo vuelve a mostrar los botones Agregar/Editar/Eliminar como si aún se pudiera
      // editar, aunque el archivo ya esté Autorizado/Cancelado.
      setSelectedData(match);
      setDisableFields(
        match?.estados_globales === ESTATUS_AUTORIZADO
        || match?.estados_globales === ESTATUS_CANCELADO,
      );
      setVisible(true);

      const totalesVista = await getExternaDescuentosTotales(key);
      setTotales(totalesVista || []);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  // ── Polling via ProcesoEnCursoTerminado (patrón Nombramientos) ───────────────
  // Consulta procesando cada 2s, actualiza progresoActual y detecta fin de tarea.
  useEffect(() => {
    if (!isPolling || !pollingSnapshot) return () => {};

    const {
      id: registroId, descripcionProceso, onCerrar, tipo,
    } = pollingSnapshot;
    let intentos = 0;
    const maxIntentos = 340; // máx ~11 min

    pollingRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({ descripcion: descripcionProceso });
        const proceso = lista[0];

        if (proceso) {
          setProgresoActual({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;

        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsPolling(false);
          setPollingSnapshot(null);
          setIdEnProceso(null);
          setIsModalProgresoVisible(false);
          setProgresoActual({ en_curso: 0, total: 0 });
          setUsarRegistrosLocales(false);

          // Verificar resultado final del registro. Se usa `tipo` (fijado explícitamente
          // al iniciar cada operación) para decidir qué pasó, NO se infiere de las banderas
          // *_exitoso del resultado: `carga_exitosa` queda en `true` para siempre desde la
          // carga original del archivo, así que inferir por esa bandera hacía que CUALQUIER
          // Autorizar (o Reactivar) entrara siempre por la rama de "Carga completada" en vez
          // de la suya — y esa rama reabre el editor vía onClickEdit() en lugar de cerrarlo,
          // dejando además `selectedData` desincronizado del estatus real (ver onClickEdit).
          try {
            const resultado = await getExternaDescuento(registroId);
            if (tipo === 'reactivar') {
              notification.success({
                message: 'Reactivación completada',
                description: 'El archivo fue reactivado correctamente.',
                placement: 'topRight',
              });
              onCerrar?.();
              await fetchData();
            } else if (tipo === 'carga' && resultado?.carga_exitosa) {
              notification.success({
                message: 'Carga completada',
                description: 'La carga de descuentos finalizó correctamente.',
                placement: 'topRight',
              });
              await fetchData();
              setSelectedRowKeys([resultado.id]);
              onClickEdit({ id: resultado.id });
            } else if (tipo === 'autorizar' && resultado?.autorizar_exitoso) {
              notification.success({
                message: 'Autorización completada',
                description: 'La autorización de descuentos finalizó correctamente.',
                placement: 'topRight',
              });
              onCerrar?.();
              await fetchData();
            } else {
              const erroresResp = await fetchAllErrores({
                descuento_carga_externa_archivo: registroId,
              });
              if (erroresResp?.length) {
                setErrores(erroresResp);
                setVisibleErrores(true);
                notification.error({
                  message: 'Errores en la operación',
                  description: 'Se encontraron errores. Revisa el historial para más detalles.',
                  placement: 'topRight',
                });
              }
            }
          } catch (_err) {
            // eslint-disable-next-line no-console
            console.error('[polling carga externa de descuentos] error al verificar el resultado final', _err);
          }
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling carga externa de descuentos] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [isPolling, pollingSnapshot]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Helper para operaciones asíncronas via ProcesoEnCursoTerminado ──────────
  // apiCall() → { id } → activa isPolling → useEffect detecta procesando===false
  const ejecutarOperacionAsync = (apiCall, _totalEstimado, { onCerrar, tipo } = {}) => {
    setProgresoActual({ en_curso: 0, total: 0 });
    setIsModalProgresoVisible(true);

    apiCall()
      .then((resultado) => {
        if (!resultado?.id) {
          setIsModalProgresoVisible(false);
          message.error('Error al iniciar la operación.');
          return;
        }
        setIdEnProceso(resultado.id);
        setPollingSnapshot({
          id: resultado.id,
          descripcionProceso: 'Carga Descuentos Externos',
          onCerrar,
          tipo,
        });
        setIsPolling(true);
      })
      .catch(() => {
        setIsModalProgresoVisible(false);
        message.error('Error al iniciar la operación.');
      });
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);

      // 1. Validar los campos del formulario antes de continuar
      await form.validateFields();

      // 2. Obtener los valores actuales del formulario
      const values = form.getFieldsValue();

      // 3. Verificar si estamos editando (tiene ID seleccionado)
      const [key] = selectedRowKeys;

      // 4. Clonar los datos del formulario para enviarlos
      const datosAEnviar = { ...values };
      // El campo "archivo" del formulario (ligado al Uploader) no es confiable para
      // obtener el File nativo; se usa el File capturado directamente en
      // handleArchivoSubido. Si no hay uno nuevo, se omite el campo por completo
      // (nunca reenviar el valor que haya quedado en el estado del formulario).
      if (archivoFileRef.current instanceof File) {
        datosAEnviar.archivo = { file: archivoFileRef.current };
      } else {
        delete datosAEnviar.archivo;
      }

      // 5. Enviar al backend: PATCH si estamos editando, POST si es nuevo
      const saved = await (
        key
          ? patchExternaDescuento(key, datosAEnviar)
          : postExternaDescuento(datosAEnviar)
      );

      // 6. Si es nuevo y hay registros cargados desde el Excel, enviarlos vía WS + PUT con progreso
      if (saved?.id && payloadRegistros?.registros?.length) {
        const { registros } = payloadRegistros;
        setLoading(false);
        ejecutarOperacionAsync(
          () => putExternaDescuento(saved.id, registros),
          registros.length,
          {
            onCerrar: () => {
              setSelectedRowKeys([saved.id]);
              setCurrentTabKey('general');
              setUsarRegistrosLocales(false);
            },
            tipo: 'carga',
          },
        );
        return;
      }

      // 7. Si es nuevo sin registros, esperar a que backend procese via ProcesoEnCursoTerminado
      if (!key && saved?.id) {
        setIdEnProceso(saved.id);
        setPollingSnapshot({
          id: saved.id,
          descripcionProceso: 'Carga Descuentos Externos',
          onCerrar: undefined,
          tipo: 'carga',
        });
        setProgresoActual({ en_curso: 0, total: 0 });
        setIsModalProgresoVisible(true);
        setIsPolling(true);
        setLoading(false);
        setSelectedRowKeys([saved.id]);
        setSelectedData(saved);
        setCurrentTabKey('general');
        return;
      }

      // 8. Si es edición o ya terminó el polling, recargar y cerrar/continuar
      if (saved) {
        if (_continue || isEditing) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved); // vuelve a abrir (o mantener abierto) si estabas editando
        } else {
          onCancel(); // solo cerrar si es nuevo y no se pidió continuar
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
    // 9. Manejo de errores con helper general
      setLoading(false); // LIBERAR PANTALLA PARA CORREGIR EL ERROR
      setIsPolling(false);
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteExternaDescuento(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const handleKeyPress = (e) => {
    if (/\d/.test(e.key)) {
      e.preventDefault();
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = async () => {
    setErrores([]); //  limpia errores anteriores
    setTotales([]); // limpia la tabla Totales
    setCurrentTabKey('general'); // siempre abre en el tab Empleados, sin importar el tab previo
    setVisibleErrores(false); //  cierra modal si estaba abierto

    form.resetFields();
    onCancel(); // limpia estados y cierra otros modales
    await fetchConceptos(); //  Carga catálogo solo si no está cargado
    await obtenerFechaServidorYSetear();
    setVisible(true); // abre el modal
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const onClickDescargarArchivo = () => {
    const [key] = selectedRowKeys;
    const match = data?.results?.find((e) => e.id === key);
    if (!match?.archivo) {
      message.warning('Este archivo no tiene documento disponible para descargar.');
      return;
    }
    window.open(match.archivo, '_blank', 'noopener,noreferrer');
  };

  const onConfirmAutorizar = () => {
    setConfirmationVisible(false);

    const [key] = selectedRowKeys;
    if (!key) {
      onSuccess({}, 'No se encontró un registro válido para autorizar');
      return;
    }

    const totalRegistros = selectedData?.numero_registros || 0;

    ejecutarOperacionAsync(
      () => autorizarExternaDescuentoAEmpleados(key),
      totalRegistros,
      { onCerrar: onCancel, tipo: 'autorizar' },
    );
  };

  // Convierte letra(s) de columna Excel a índice 0-based (A=0, B=1, Z=25, AA=26, ...)
  const colLetterToIndex = (letter) => {
    const upper = (letter || '').trim().toUpperCase();
    let result = 0;
    for (let i = 0; i < upper.length; i += 1) {
      result = result * 26 + (upper.charCodeAt(i) - 64);
    }
    return result - 1;
  };

  // Limpia símbolo de moneda y separador de miles antes de convertir a número (mismo
  // criterio que parse_decimal en el backend, sac/utils/excel_parsers.py). Sin esto,
  // parseFloat("$1,500.00") da NaN (la fila se descarta en silencio) y, peor,
  // parseFloat("1,500.00") -- sin símbolo, un error de captura plausible en un Excel --
  // se detiene en la primera coma y regresa 1, guardando silenciosamente un importe 1500
  // veces menor al real sin ningún error ni advertencia.
  const parseImporteCelda = (valorCelda) => {
    if (typeof valorCelda === 'number') return valorCelda;
    const texto = String(valorCelda ?? '').trim();
    if (!texto) return NaN;
    const limpio = texto.replace(/[^\d.-]/g, '');
    return limpio === '' ? NaN : parseFloat(limpio);
  };

  const handleArchivoSubido = async (file) => {
    try {
      // 1. Validar configuración
      if (!Array.isArray(ConfiguracionExterna) || ConfiguracionExterna.length === 0) {
        message.error('La configuración de columnas aún no está cargada. Intenta de nuevo.');
        return;
      }

      // Se conserva el archivo original (XLSX/CSV) para guardarlo y poder descargarlo despues
      archivoFileRef.current = file;

      // 2. Leer archivo (Excel o CSV)
      const datas = await file.arrayBuffer();
      const isCsv = file.name.split('.').pop().toLowerCase() === 'csv';
      const workbook = XLSX.read(datas, { type: 'array', raw: isCsv });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // 3. Obtener configuración del concepto
      const idConceptoSeleccionado = form.getFieldValue('descuento_carga_externa');
      const configConcepto = ConfiguracionExterna.find((c) => c.id === idConceptoSeleccionado);

      if (!configConcepto) {
        message.error('No se encontró configuración para el concepto seleccionado');
        return;
      }

      // 4. Convertir letras de columna a índices
      const idxNumEmpleado = colLetterToIndex(configConcepto.columna_del_numero_del_empleado);
      const idxNombreEmpleado = colLetterToIndex(configConcepto.columna_del_nombre_del_empleado);
      // eslint-disable-next-line max-len
      const idxDescripcion = colLetterToIndex(configConcepto.columna_de_descripcion_del_concepto_externo);
      const idxImporte = colLetterToIndex(configConcepto.columna_del_importe);

      // 5. Leer hoja completa como array de arrays
      const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });

      // 6. Procesar filas (saltar fila 0 que es el encabezado)
      const registros = [];

      for (let i = 1; i < sheetData.length; i += 1) {
        const rowArray = sheetData[i];
        if (Array.isArray(rowArray) && !rowArray.every((cell) => cell === '')) {
          const numero_de_empleado = String(rowArray[idxNumEmpleado] ?? '')?.trim();
          const nombre_del_empleado = String(rowArray[idxNombreEmpleado] ?? '')?.trim();
          const descripcion_del_concepto_externo = String(rowArray[idxDescripcion] ?? '')?.trim();
          const importe = parseImporteCelda(rowArray[idxImporte]);

          const registroValido = numero_de_empleado && nombre_del_empleado
                                && descripcion_del_concepto_externo && !Number.isNaN(importe);

          if (registroValido) {
            registros.push({
              renglon: i + 1,
              numero_de_empleado,
              nombre_del_empleado,
              descripcion_del_concepto_externo,
              importe,
            });
          }
        }
      }

      // 7. Mostrar advertencia si hubo descartados
      const totalFilasAnalizadas = sheetData.length - 1;
      const descartados = totalFilasAnalizadas - registros.length;

      if (descartados > 0) {
        message.warning(`${descartados} registros fueron descartados por tener campos vacíos.`);
      }

      // 11. Armar y guardar payload
      const payload = { registros };
      registrosExcelRef.current = registros;
      setPayloadRegistros(payload);
      setExcelUpdateKey((prev) => prev + 1);
      setUsarRegistrosLocales(true);

      // 12. Actualizar formulario
      form.setFieldsValue({
        archivo_nombre: file.name,
        numero_empleados: new Set(registros.map((r) => r.numero_de_empleado)).size,
        numero_registros: registros.length,
      });

      message.success(`Archivo leído correctamente. ${payload.registros.length} registros listos.`);
    } catch (error) {
      message.error('Error al leer el archivo');
    }
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede modificar una nómina ya cancelada');
        return;
      }

      const res = await CancelarExternaDescuento(key);

      if (res) {
        onCancel(); // ⬅ Cierra modal y limpia estados
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    const [key] = selectedRowKeys;
    if (!key) {
      onCancel();
      onSuccess({}, 'No se encontró un registro válido para reactivar');
      return;
    }

    // Reactivar desde Autorizado cancela los Descuentos Empleado de esa autorización
    // (mismo tratamiento que Cancelar) vía una tarea asíncrona en el backend — hay que
    // esperar a que termine (polling) antes de refrescar, igual que Autorizar/Carga, o
    // la tabla se recarga con el estatus aún viejo. Reactivar desde Cancelado sigue
    // siendo síncrono en el backend (no hay nada que cancelar), así que no requiere polling.
    if (selectedData?.estados_globales === ESTATUS_AUTORIZADO) {
      setVisibleReactivar(false);
      ejecutarOperacionAsync(
        () => reactivarExternaDescuento(key),
        selectedData?.numero_registros || 0,
        { onCerrar: onCancel, tipo: 'reactivar' },
      );
      return;
    }

    try {
      setLoading(true);
      const res = await reactivarExternaDescuento(key);

      if (res) {
        onCancel(); // ⬅ Cierra modal y limpia estados
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onErrors = () => {
    setVisibleErrores(true);
  };

  const handleExportReporte = async (reportType) => {
    /* eslint-disable no-param-reassign, no-plusplus */
    const [key] = selectedRowKeys;
    if (!key) {
      message.warn('Por favor, seleccione un registro para exportar.');
      return;
    }

    setLoading(true);
    try {
      const response = await API.get(
        `nominas/descuentos-carga-externa-archivo-empleado-vista-optimized/${key}/`,
      );
      const allDetalles = response?.data || [];

      if (allDetalles.length === 0) {
        message.info('No hay registros de empleados para exportar en este archivo.');
        setLoading(false);
        return;
      }

      // PATRONAL (Fondo de Pensiones) y VIVIENDA (Fondos de Vivienda): aportaciones que paga
      // la entidad, no se descuentan al empleado, por lo que no viven en la carga externa sino
      // en el calculo de la nomina (nominas_plazas_ipejal). Se mapean al mismo formato para
      // reutilizar la clasificacion Plantilla/Seguridad/Eventual de abajo sin duplicar la regla.
      const CONCEPTO_IPEJAL_A_NOMBRE_REPORTE = {
        'FONDO DE PENSIONES': 'PATRONAL',
        'FONDOS DE VIVIENDA': 'VIVIENDA',
      };
      const patronalViviendaRaw = await getReporteIPEJALPatronalVivienda(key);
      const patronalViviendaDetalles = (patronalViviendaRaw || [])
        .filter((item) => CONCEPTO_IPEJAL_A_NOMBRE_REPORTE[item.concepto])
        .map((item) => ({
          descripcion_del_concepto_externo: CONCEPTO_IPEJAL_A_NOMBRE_REPORTE[item.concepto],
          importe: item.importe,
          tipo_de_empleado_presupuestal_clave: item.tipo_de_empleado_presupuestal_clave,
        }));
      allDetalles.push(...patronalViviendaDetalles);

      const normalize = (str) => (str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim();

      const groupedData = {};
      const sedarGrouped = {
        'Aportacion Adicional Voluntaria SEDAR': {
          concepto: 'Aportacion Adicional Voluntaria SEDAR',
          ipejal: 0,
          plantilla: 0,
          seguridad: 0,
          eventual: 0,
        },
        'Aportacion Adicional Complementaria SEDAR': {
          concepto: 'Aportacion Adicional Complementaria SEDAR',
          ipejal: 0,
          plantilla: 0,
          seguridad: 0,
          eventual: 0,
        },
        'Aportación al SEDAR': {
          concepto: 'Aportación al SEDAR',
          ipejal: 0,
          plantilla: 0,
          seguridad: 0,
          eventual: 0,
        },
      };

      allDetalles.forEach((item) => {
        const concepto = item.descripcion_del_concepto_externo || 'SIN CONCEPTO';
        const importe = parseFloat(item.importe) || 0;
        const grupo = clasificarGrupoIPEJAL(item);
        const normalizedConcept = normalize(concepto);

        let targetGroup = null;
        if (normalizedConcept === normalize('Aportacion Adicional Voluntaria SEDAR')) {
          targetGroup = sedarGrouped['Aportacion Adicional Voluntaria SEDAR'];
        } else if (
          normalizedConcept === normalize('Aportacion Adicional Complementaria SEDAR')
        ) {
          targetGroup = sedarGrouped['Aportacion Adicional Complementaria SEDAR'];
        } else if (normalizedConcept === normalize('Aportación al SEDAR')) {
          targetGroup = sedarGrouped['Aportación al SEDAR'];
        }

        if (!targetGroup) {
          if (!groupedData[concepto]) {
            groupedData[concepto] = {
              concepto,
              ipejal: 0,
              plantilla: 0,
              seguridad: 0,
              eventual: 0,
            };
          }
          targetGroup = groupedData[concepto];
        }
        targetGroup.ipejal += importe;
        if (grupo) targetGroup[grupo] += importe;
      });

      const upperRows = Object.values(groupedData);
      const lowerRows = Object.values(sedarGrouped);

      let totalUpperIpejal = 0;
      let totalUpperPlantilla = 0;
      let totalUpperSeguridad = 0;
      let totalUpperEventual = 0;

      upperRows.forEach((r) => {
        totalUpperIpejal += r.ipejal;
        totalUpperPlantilla += r.plantilla;
        totalUpperSeguridad += r.seguridad;
        totalUpperEventual += r.eventual;
      });

      let totalSedarIpejal = 0;
      let totalSedarPlantilla = 0;
      let totalSedarSeguridad = 0;
      let totalSedarEventual = 0;

      lowerRows.forEach((r) => {
        totalSedarIpejal += r.ipejal;
        totalSedarPlantilla += r.plantilla;
        totalSedarSeguridad += r.seguridad;
        totalSedarEventual += r.eventual;
      });

      const selectedRecord = data?.results?.find((e) => e.id === key) || selectedData;

      const periodosText = selectedRecord?.periodos_de_nomina_detalle?.map((id) => {
        const d = periodosNominasDetalles.find((e) => e.id === id);
        if (!d) return '';
        return `${d.numero_de_nomina} (${fechaDMY(d.fecha_inicial)} al ${fechaDMY(d.fecha_final)})`;
      }).filter(Boolean).join(', ') || 'Sin datos';

      const tiposNominaText = selectedRecord?.tipos_de_nomina_empleado?.map((id) => tiposNominasEmpleados.find((e) => e.id === id)?.descripcion).filter(Boolean).join(', ') || 'Sin datos';

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Conciliación IPEJAL');

      worksheet.columns = [
        { header: '', key: 'concepto', width: 45 },
        { header: '', key: 'ipejal', width: 18 },
        { header: '', key: 'plantilla', width: 18 },
        { header: '', key: 'seguridad', width: 18 },
        { header: '', key: 'eventual', width: 18 },
        { header: '', key: 'diferencia', width: 18 },
      ];

      worksheet.addRow(['SISTEMA DE NÓMINAS']).font = {
        bold: true,
        size: 14,
        name: 'Calibri',
      };
      worksheet.addRow([
        `REPORTE DE CONCILIACIÓN DE DESCUENTOS EXTERNOS - ${reportType}`,
      ]).font = { bold: true, size: 12, name: 'Calibri' };
      worksheet.addRow([`Entidad: ${entidad?.nombre || ''}`]).font = { name: 'Calibri' };
      worksheet.addRow([
        `Concepto de Descuento: ${selectedRecord?.concepto_carga_externa_nombre || ''}`,
      ]).font = { name: 'Calibri' };
      worksheet.addRow([`Archivo: ${selectedRecord?.archivo_nombre || ''}`]).font = {
        name: 'Calibri',
      };
      worksheet.addRow([
        `Fecha de Carga: ${
          selectedRecord?.fecha_de_carga
            ? moment(selectedRecord.fecha_de_carga).format('DD/MM/YYYY')
            : ''
        }`,
      ]).font = { name: 'Calibri' };
      worksheet.addRow([`Tipos de Nómina: ${tiposNominaText}`]).font = { name: 'Calibri' };
      worksheet.addRow([`Periodos de Nómina: ${periodosText}`]).font = { name: 'Calibri' };
      worksheet.addRow([]);

      const headerRow = worksheet.addRow([
        'CONCEPTO',
        'IPEJAL',
        'PLANTILLA',
        'SEGURIDAD',
        'EVENTUAL',
        'DIFERENCIA',
      ]);

      headerRow.eachCell((cell) => {
        cell.font = { bold: true, name: 'Calibri', size: 11 };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE0E0E0' },
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFB0B0B0' } },
          left: { style: 'thin', color: { argb: 'FFB0B0B0' } },
          bottom: { style: 'thin', color: { argb: 'FFB0B0B0' } },
          right: { style: 'thin', color: { argb: 'FFB0B0B0' } },
        };
      });

      const r2 = (n) => Math.round(n * 100) / 100;

      upperRows.forEach((r) => {
        const ipejal = r2(r.ipejal);
        const plantilla = r2(r.plantilla);
        const seguridad = r2(r.seguridad);
        const eventual = r2(r.eventual);
        const diferencia = r2(plantilla + seguridad + eventual - ipejal);

        const row = worksheet.addRow([
          r.concepto,
          ipejal,
          plantilla,
          seguridad,
          eventual,
          diferencia,
        ]);

        row.getCell(1).alignment = { horizontal: 'left' };
        for (let col = 2; col <= 6; col++) {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00';
          cell.alignment = { horizontal: 'right' };
        }
      });

      const totalGeneralRow = worksheet.addRow([
        'TOTAL GENERAL',
        r2(totalUpperIpejal),
        r2(totalUpperPlantilla),
        r2(totalUpperSeguridad),
        r2(totalUpperEventual),
        r2(
          totalUpperPlantilla
            + totalUpperSeguridad
            + totalUpperEventual
            - totalUpperIpejal,
        ),
      ]);

      totalGeneralRow.eachCell((cell, colIndex) => {
        cell.font = { bold: true, name: 'Calibri', size: 11 };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'double', color: { argb: 'FF000000' } },
        };
        if (colIndex >= 2) {
          cell.numFmt = '#,##0.00';
          cell.alignment = { horizontal: 'right' };
        } else {
          cell.alignment = { horizontal: 'left' };
        }
      });

      worksheet.addRow([]);
      worksheet.addRow([]);

      lowerRows.forEach((r) => {
        const ipejal = r2(r.ipejal);
        const plantilla = r2(r.plantilla);
        const seguridad = r2(r.seguridad);
        const eventual = r2(r.eventual);
        const diferencia = r2(plantilla + seguridad + eventual - ipejal);

        const row = worksheet.addRow([
          r.concepto,
          ipejal,
          plantilla,
          seguridad,
          eventual,
          diferencia,
        ]);

        row.getCell(1).alignment = { horizontal: 'left' };
        for (let col = 2; col <= 6; col++) {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00';
          cell.alignment = { horizontal: 'right' };
        }
      });

      const totalSedarRow = worksheet.addRow([
        'TOTAL SEDAR',
        r2(totalSedarIpejal),
        r2(totalSedarPlantilla),
        r2(totalSedarSeguridad),
        r2(totalSedarEventual),
        r2(
          totalSedarPlantilla
            + totalSedarSeguridad
            + totalSedarEventual
            - totalSedarIpejal,
        ),
      ]);

      totalSedarRow.eachCell((cell, colIndex) => {
        cell.font = { bold: true, name: 'Calibri', size: 11 };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'double', color: { argb: 'FF000000' } },
        };
        if (colIndex >= 2) {
          cell.numFmt = '#,##0.00';
          cell.alignment = { horizontal: 'right' };
        } else {
          cell.alignment = { horizontal: 'left' };
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fileName = `REPORTE_${reportType.replace(/\s+/g, '_')}_${
        selectedRecord?.archivo_nombre || key
      }.xlsx`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success('Reporte exportado correctamente');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      message.error('Ocurrió un error al exportar el reporte');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      titleText: 'Fecha de Carga',
      dataIndex: 'fecha_de_carga',
      key: 'fecha_de_carga',
      width: 400,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Concepto de Descuento',
      dataIndex: 'concepto_carga_externa_nombre',
      key: 'concepto_carga_externa_nombre',
      width: 400,
    },
    {
      titleText: 'Nombre del Archivo',
      dataIndex: 'archivo_nombre',
      key: 'archivo_nombre',
      width: 400,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipos_de_nomina_empleado',
      key: 'tipos_de_nomina_empleado',
      width: 400,
      render: (val) => val?.map((id) => tiposNominasEmpleados.find((e) => e.id === id)?.descripcion).join(', ') || 'Sin datos',
    },
    {
      titleText: 'Periodo de Nómina de Aplicación ',
      dataIndex: 'periodos_de_nomina_detalle',
      key: 'periodos_de_nomina_detalle',
      width: 400,
      render: (val) => {
        const ids = Array.isArray(val) ? val : [];

        const textos = ids.map((id) => {
          const detalle = periodosNominasDetalles.find((e) => e.id === id);
          if (!detalle) return 'Desconocido';

          return `${detalle.numero_de_nomina}  (${fechaDMY(detalle.fecha_inicial)} al ${fechaDMY(detalle.fecha_final)})`;
        });

        return textos.length ? textos.join(', ') : 'Sin datos';
      },
    },
    {
      titleText: 'Número de Empleados ',
      dataIndex: 'numero_registros',
      key: 'numero_registros',
      width: 400,
    },
    {
      titleText: 'Importe Total',
      dataIndex: 'importe_total',
      key: 'importe_total',
      width: 400,
      render: (val) => currencyFormatter(val || 0),
    },

    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 200,
      // Tag con color por estatus (mismo criterio que Registro de Incidencias y
      // Asignación de Plazas). Se decide por el texto porque el Table a veces llama a
      // render sin el registro (ordenamiento).
      render: (descripcion) => {
        if (!descripcion) return null;
        const upper = String(descripcion).toUpperCase();
        let color = 'blue';
        if (upper.includes('AUTORIZ')) color = 'green';
        if (upper.includes('CANCEL')) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  const columnsTotales = [
    {
      titleText: 'Concepto de Carga Externa',
      dataIndex: 'concepto_de_carga_externa',
      key: 'concepto_de_carga_externa',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 200,
    },
    {
      titleText: 'Clave y Concepto',
      dataIndex: 'clave_y_concepto',
      key: 'clave_y_concepto',
      width: 200,
    },
    {
      titleText: 'Concepto Relacionado',
      dataIndex: 'concepto_relacionado',
      key: 'concepto_relacionado',
      width: 200,
    },
    {
      titleText: 'Empleados',
      dataIndex: 'empleados',
      key: 'empleados',
      width: 200,
      align: 'center',
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  // Fila de totales (suma de Empleados e Importe) al pie de la tabla del tab Totales.
  const summaryCellsTotales = [
    {
      label: 'Total',
      labelColSpan: 4,
      value: totales.reduce((suma, actual) => suma + (Number(actual?.empleados) || 0), 0),
      valueAlign: 'center',
    },
    {
      value: totales.reduce((suma, actual) => suma + (Number(actual?.importe) || 0), 0),
      valueAlign: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  const handleExportExcel = () => {
    const fileName = permission?.permissionModel || 'TABLA';
    const worksheet = XLSX.utils.json_to_sheet(
      (data?.results || []).map((record) => columns.reduce((obj, col) => {
        // eslint-disable-next-line no-param-reassign
        obj[col.titleText] = col.render
          ? col.render(record[col.dataIndex], record)
          : record[col.dataIndex];
        return obj;
      }, {})),
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const handleExportPDF = async () => {
    const fileName = permission?.permissionModel || 'TABLA';
    const dataCols = columns.length > 9
      ? [...columns.slice(0, 9), columns[columns.length - 1]]
      : columns;
    const allData = (data?.results || []).map((record) => dataCols.reduce((obj, col) => {
      // eslint-disable-next-line no-param-reassign
      obj[col.titleText] = col.render
        ? col.render(record[col.dataIndex], record)
        : record[col.dataIndex];
      return obj;
    }, {}));
    const formattedDate = format(new Date(), "eeee, dd 'de' MMMM 'de' yyyy", { locale: es });
    try {
      const pdfData = await descargarPDFGeneral(
        entidad?.id,
        fileName,
        dataCols,
        allData,
        formattedDate,
      );
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}.pdf`;
      link.click();
    } catch (err) {
      onError(err);
    }
  };

  const customExportMenu = (
    <Menu
      items={[
        {
          key: 'excel',
          label: 'Excel',
          icon: <FileExcelOutlined />,
          onClick: handleExportExcel,
        },
        {
          key: 'pdf',
          label: 'PDF',
          icon: <FilePdfOutlined />,
          onClick: handleExportPDF,
        },
        {
          key: 'reporte_ipejal',
          label: 'REPORTE IPEJAL',
          icon: <DownloadOutlined />,
          onClick: () => handleExportReporte('IPEJAL'),
        },
        {
          key: 'reporte_ipejal_retroactivo',
          label: 'REPORTE IPEJAL RETROACTIVO',
          icon: <DownloadOutlined />,
          onClick: () => handleExportReporte('IPEJAL RETROACTIVO'),
        },
      ]}
    />
  );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  // true si hay un registro seleccionado y su estatus está entre los permitidos.
  const seleccionEnEstados = (estadosPermitidos) => !!selectedRowKeys?.length
    && estadosPermitidos.includes(selectedData?.estados_globales);

  const listaTable = (
    <Table
      cols={columns}
      data={data?.results || []}
      rowSelection={rowSelection}
      pagination={false}
      paginationCallback={fetchPaginated}
      count={data?.count || 0}
      storageId={TABLE_STORAGE_ID}
      handleOnRowClick={handleOnRowClick}
      controls={{
        onClickAdd,
        onClickEdit: () => onClickEdit(),
        onClickDelete,
      }}
      customActions={[
        // Cancelar: todos los tabs salvo Cancelados; Reactivar: todos salvo Activos. En
        // "Todos" aparecen ambos y se habilitan según el estatus del registro seleccionado.
        ...(tabEstadoActivo !== 'cancelados' ? [{
          permission: { model: 'descuentocargaexternaarchivo', action: 'cancelar' },
          onClick: () => setVisibleCancelar(true),
          text: 'Cancelar',
          icon: <CloseCircleOutlined />,
          disabledBySelection: false,
          className: 'cancel',
          disabled: !seleccionEnEstados([ESTATUS_ACTIVO, ESTATUS_AUTORIZADO]),
        }] : []),
        ...(tabEstadoActivo !== 'activos' ? [{
          permission: { model: 'descuentocargaexternaarchivo', action: 'reactivar' },
          onClick: () => setVisibleReactivar(true),
          text: 'Reactivar',
          icon: <RedoOutlined />,
          disabledBySelection: false,
          className: 'success',
          disabled: !seleccionEnEstados([ESTATUS_AUTORIZADO, ESTATUS_CANCELADO]),
        }] : []),
        {
          onClick: onClickDescargarArchivo,
          text: 'Descargar',
          icon: <DownloadOutlined />,
          disabledBySelection: false,
          disabled: !selectedRowKeys?.length,
        },
      ]}
      customActionsDropdown
      customActionsDropdownText="Acciones"
      // eslint-disable-next-line max-len
      disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO || selectedData?.estados_globales === ESTATUS_CANCELADO}
      permission={permission}
      // allowExportPDF={false}
      allowCustomExport
      customExportMenu={customExportMenu}
    />
  );

  return (
    <Row className="container">
      <Spin
        tip="Cargando..."
        spinning={isSpinning}
      >
        {!open ? (
          // Card `tables-container` para que la tabla se ajuste al alto de la ventana
          // (igual que Registro de Incidencias / Asignación de Plazas).
          <Card bordered={false} className="tables-container">
            <Tabs
              activeKey={tabEstadoActivo}
              onChange={onChangeTabEstado}
              type="card"
              destroyInactiveTabPane
              items={[
                { key: 'todos', label: 'Todos', children: listaTable },
                { key: 'activos', label: 'Activos', children: listaTable },
                { key: 'autorizados', label: 'Autorizados', children: listaTable },
                { key: 'cancelados', label: 'Cancelados', children: listaTable },
              ]}
            />
          </Card>
        ) : (
          <>
            {
              errores.length ? (
                <Alert
                  description={(
                    <code>
                      <Text>
                        Ha ocurrido un error
                      </Text>
                      <br />
                      Favor de consultar el
                      <Text
                        style={{
                          color: '#CF9660',
                          paddingLeft: '3px',
                          paddingRight: '3px',
                        }}
                      >
                        Historial de Errores
                      </Text>
                      para obtener mas información
                    </code>
                )}
                  type="warning"
                  showIcon
                  closable
                  style={{ textAlign: 'center', alignItems: 'center' }}
                />
              ) : null
            }

            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'EDITAR' : 'AGREGAR'} CARGA EXTERNA DE DESCUENTOS`}
              extra={(
                <Row gutter={10} align="middle">
                  {isEditing && selectedData?.estados_globales === ESTATUS_ACTIVO && (
                  <Col>
                    <Button
                      className="success"
                      icon={<CheckCircleOutlined />}
                      onClick={() => setConfirmationVisible(true)}
                      loading={loading}
                    >
                      Autorizar
                    </Button>
                  </Col>
                  )}
                  <Col>
                    <FormSubmitControls
                      onFinish={onFinish}
                      onCancel={onCancel}
                      loading={loading}
                      onFinishText="Guardar y Continuar"
                      onErrors={errores.length ? onErrors : null}
                      mutable={selectedData?.estados_globales !== ESTATUS_AUTORIZADO}
                    />
                  </Col>
                </Row>
  )}
              bordered={false}
            >
              <Tabs
                onChange={setCurrentTabKey}
                activeKey={currentTabKey}
                type="card"
              >
                <TabPane
                  tab="Empleados"
                  key="general"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    form={form}
                    name="general"
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>
                      {/* Concepto */}
                      <Col xs={24} sm={8}>
                        <Form.Item
                          name="descuento_carga_externa"
                          label="Concepto de Descuento"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            dataSource={ConfiguracionExterna}
                            labelProp="concepto_carga_externa_nombre"
                            keyProp="id"
                            allowClear
                            showSearch
                            placeholder="Seleccione un concepto"
                            disabled={isEditing}
                            onChange={() => {
                              // 1) Vacía los campos relacionados con el archivo
                              form.setFieldsValue({
                                archivo: undefined,
                                archivo_nombre: undefined,
                                numero_empleados: undefined,
                                numero_registros: undefined,
                              });

                              // 2) Elimina la carga ya procesada en estado React
                              setPayloadRegistros({ registros: [] });
                              registrosExcelRef.current = [];
                            }}
                          />
                        </Form.Item>
                      </Col>

                      {/* Fecha de carga del servidor */}
                      <Col xs={24} sm={8}>
                        <Form.Item
                          name="fecha_de_carga"
                          label="Fecha de Carga"
                          hasFeedback
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      {/*
                    <Col xs={24} sm={24} md={24}>
                      <Form.Item
                        name="descuento_carga_externa"
                        label="Concepto de Descuento"
                        rules={[{ required: true, message: 'Campo requerido' }]}
                      >
                        <Select
                          labelProp="descripcion"
                          keyProp="id"
                          dataSource={descuentos}
                          allowClear
                          placeholder="Seleccione un concepto"
                        />
                      </Form.Item>
                    </Col> */}
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          name="archivo_nombre"
                          label="Nombre del Archivo"
                          rules={[{ required: true, message: 'Campo requerido' }]}
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          name="numero_registros"
                          label="Número de Registros"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipos_de_nomina_empleado"
                          label="Tipo de Nómina Empleado"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            mode="multiple"
                            dataSource={tiposNominasEmpleados}
                            onChange={(value) => {
                              const nomina = tiposNominasEmpleados.find((e) => e.id === value?.[0]);
                              setPeriodo(nomina?.periodicidad_de_pago);
                              form.resetFields(['periodos_de_nomina_detalle', 'periodo_fiscal', 'dias_calculados']);
                              filterPeriodos();
                            }}
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="periodo_fiscal"
                          label="Periodo Fiscal"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            dataSource={periodosFiscales}
                          // disabled={selectedRowKeys.length}
                            onChange={() => {
                              form.resetFields(['periodos_de_nomina_detalle', 'dias_calculados']);
                              filterPeriodos();
                            }}
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="periodos_de_nomina_detalle"
                          label="Periodo"
                          dependencies={['tipos_de_nomina_empleado']}
                          rules={[
                            ...rules.required,
                            {
                              validator: (_regla, value) => {
                                const tiposSel = form.getFieldValue('tipos_de_nomina_empleado') || [];
                                if (!tiposSel.length || !value?.length) return Promise.resolve();
                                const tiposCubiertos = new Set(
                                  value
                                    .map((detalleId) => periodosNominasDetalles
                                      .find((e) => e.id === detalleId)?.periodo_de_nomina)
                                    .map((pnId) => periodosNominas
                                      .find((e) => e.id === pnId)?.tipo_de_nomina_empleado)
                                    .filter(Boolean),
                                );
                                const tiposFaltantes = tiposSel
                                  .filter((id) => !tiposCubiertos.has(id));
                                if (!tiposFaltantes.length) return Promise.resolve();
                                const nombresFaltantes = tiposFaltantes
                                  .map((id) => tiposNominasEmpleados
                                    .find((e) => e.id === id)?.descripcion)
                                  .filter(Boolean)
                                  .join(', ');
                                return Promise.reject(new Error(
                                  `Falta seleccionar un Periodo para: ${nombresFaltantes}`,
                                ));
                              },
                            },
                          ]}
                          hasFeedback
                        >
                          <Select
                            mode="multiple"
                            keyProp="id"
                            labelProp="numero_de_nomina"
                          // disabled={selectedRowKeys.length}
                          // eslint-disable-next-line max-len
                            dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))}
                            render={(value) => `${value?.numero_de_nomina} (${fechaDMY(value?.fecha_inicial)} al ${fechaDMY(value?.fecha_final)})`}
                            onChange={(val) => {
                              // eslint-disable-next-line max-len
                              const _periodo = periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id));
                              // eslint-disable-next-line max-len
                              const _diasCalculados = _periodo?.find((e) => e.id === val)?.no_de_dias;
                              form.setFieldValue('dias_calculados', _diasCalculados);
                            }}
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>

                      {/* Estatus (solo lectura) */}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          rules={rules.estatus}
                          hasFeedback
                          initialValue={1}
                        >
                          <Select
                            labelProp="descripcion"
                            keyProp="id"
                            dataSource={estados}
                            disabled
                          />
                        </Form.Item>
                      </Col>

                      <Form.Item
                        // eslint-disable-next-line max-len
                        shouldUpdate={(prev, cur) => prev.descuento_carga_externa !== cur.descuento_carga_externa}
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <>

                            <Uploader
                              title="Documento"
                              limitMB={10}
                              file={getFieldValue('archivo')}
                              formItemName="archivo"
                              allowedExtensions={['xlsx', 'csv']}
                              allowPreview={false}
                              dragger
                              draggerStyle={{ height: 80, padding: '8px 0' }}
                              onUpload={handleArchivoSubido}
                              disabled={
          disableFields
          || !getFieldValue('descuento_carga_externa')
          || selectedData?.carga_exitosa
        }
                            />
                            {selectedData?.carga_exitosa && (
                            <Alert
                              message="La carga fue exitosa"
                              description="Ya no es posible modificar el archivo cargado."
                              type="success"
                              showIcon
                              style={{ marginBottom: 16 }}
                            />
                            )}
                          </>
                        )}
                      </Form.Item>

                    </Row>

                  </Form>
                  <CargaExternaDescuentoDetalle
                    key={excelUpdateKey}
                  // eslint-disable-next-line max-len
                    CargaExternaDescuento={selectedData}
                  // eslint-disable-next-line max-len
                    registrosCargados={usarRegistrosLocales ? registrosExcelRef.current : []} // <-- Aquí pasas los datos del Excel
                    permission={getModelPermission('descuentocargaexternaarchivoempleado')}
                    hideParentForm={() => setVisible(false)}
                    showParentForm={() => setVisible(true)}
                    pollingEnCurso={isPolling}
                    usarRegistrosLocales={usarRegistrosLocales}

                  />
                </TabPane>

                <TabPane
                  tab="Totales"
                  key="Total"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    form={form}
                    name="Total"
                  >
                    <Row gutter={10}>
                      <Col span={24}>
                        <Table
                          cols={columnsTotales}
                          data={totales}
                          pagination={false}
                          rowSelection={rowSelection}
                          handleOnRowClick={handleOnRowClick}
                          permission={permission}
                          summaryCells={summaryCellsTotales}
                        />
                      </Col>
                    </Row>
                  </Form>
                </TabPane>

              </Tabs>
            </Card>
          </>
        )}
        <Modal
          open={visibleErrores}
          title={(
            <Row justify="space-between">
              <Text style={{ fontSize: '1.25rem' }}>
                Historial de Errores
              </Text>
              <ModalErroresControls
                onCancel={() => setVisibleErrores(false)}
              />
            </Row>
                )}
          footer={null}
          closable={false}
          width="85%"
        >
          <Table
            cols={[{
              titleText: 'Descripción de Error',
              dataIndex: 'error',
              key: 'error',
              width: 200,
            }]}
            data={errores}
            mobileColIndex={0}
          />
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={form.getFieldValue('archivo_nombre') || ''}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          Confirm
          onCancel={() => setVisibleCancelar(false)}
          open={visibleCancelar}
          contentTitle={`Cancelar el Archivo ${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          Confirm
          onCancel={() => setVisibleReactivar(false)}
          open={visibleReactivar}
          contentTitle={`Reactivar el Archivo ${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Archivo ${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />

        {/* Modal de progreso para carga y autorización */}
        <Modal
          title="Procesando operación..."
          open={isModalProgresoVisible}
          footer={null}
          closable={false}
          maskClosable={false}
          width={480}
        >
          {isModalProgresoVisible && (
            <div style={{ padding: '8px 0' }}>
              {progresoActual.total > 0 ? (
                <>
                  <p style={{ marginBottom: 6, color: '#595959' }}>
                    {`Procesando ${progresoActual.en_curso} de ${progresoActual.total} registros...`}
                  </p>
                  <div
                    style={{
                      background: '#f0f0f0',
                      borderRadius: 4,
                      overflow: 'hidden',
                      height: 12,
                      marginBottom: 4,
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: `${Math.round((progresoActual.en_curso / progresoActual.total) * 100)}%`,
                        background: '#1890ff',
                        borderRadius: 4,
                        transition: 'width 0.5s ease',
                      }}
                    />
                  </div>
                  <p
                    style={{
                      textAlign: 'right', fontSize: 12, color: '#8c8c8c', margin: 0,
                    }}
                  >
                    {`${Math.round((progresoActual.en_curso / progresoActual.total) * 100)}%`}
                  </p>
                </>
              ) : (
                <>
                  <p style={{ marginBottom: 8, color: '#595959' }}>
                    Por favor espere, esto puede tomar varios minutos...
                  </p>
                  <div
                    style={{
                      background: '#f0f0f0',
                      borderRadius: 4,
                      overflow: 'hidden',
                      height: 12,
                      marginBottom: 12,
                      position: 'relative',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        height: '100%',
                        width: '40%',
                        background: '#1890ff',
                        borderRadius: 4,
                        animation: 'indeterminate 1.4s infinite ease-in-out',
                      }}
                    />
                  </div>
                  <style>
                    {'@keyframes indeterminate { 0% { left: -40%; } 100% { left: 110%; } }'}
                  </style>
                </>
              )}
            </div>
          )}
        </Modal>
      </Spin>
    </Row>
  );
};

export default CargaExternaDescuento;
